import {
  pickSiteSocialLinksFromContent,
  type LayoutBlock,
  type SiteSocialNetworkKey,
} from '@web-studio/shared-schemas';
import { SITE_SOCIAL_ICONS } from '../icons/socialNetworks';
import { renderSocialIconHtml } from '../icons/renderIconHtml';
import { pickChrome } from '../lib/siteChromeCopy';
import { escapeHtml } from './escape';

const NETWORK_LABEL: Record<SiteSocialNetworkKey, string> = {
  facebook: SITE_SOCIAL_ICONS.facebook.title,
  instagram: SITE_SOCIAL_ICONS.instagram.title,
  tiktok: SITE_SOCIAL_ICONS.tiktok.title,
  x: SITE_SOCIAL_ICONS.x.title,
  youtube: SITE_SOCIAL_ICONS.youtube.title,
};

export type SiteSocialHtmlSurface = 'footer' | 'nav';

export function renderSiteSocialLinksHtml(
  content: LayoutBlock['content'],
  locale: string,
  options?: {
    showHeading?: boolean;
    wrapClass?: string;
    surface?: SiteSocialHtmlSurface;
  },
): string {
  const links = pickSiteSocialLinksFromContent(content, locale);
  if (links.length === 0) {
    return '';
  }
  const surface = options?.surface ?? 'footer';
  const wrapBase = surface === 'nav' ? 'ws-nav__social-wrap' : 'ws-footer__social-wrap';
  const navClass = surface === 'nav' ? 'ws-nav__social' : 'ws-footer__social';
  const listClass = surface === 'nav' ? 'ws-nav__social-list' : 'ws-footer__social-list';
  const linkClass = surface === 'nav' ? 'ws-nav__social-link' : 'ws-footer__social-link';
  const headingClass = surface === 'nav' ? 'ws-nav__social-heading' : 'ws-footer__heading';

  const heading = options?.showHeading
    ? `<p class="${headingClass}">${escapeHtml(pickChrome('footerSocial', locale))}</p>`
    : '';
  const list = `<ul class="${listClass}">${links
    .map(({ network, url }) => {
      const icon = renderSocialIconHtml(network, { size: 'md' });
      return `<li><a class="${linkClass}" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer" aria-label="${escapeHtml(NETWORK_LABEL[network])}">${icon}</a></li>`;
    })
    .join('')}</ul>`;
  const nav = `<nav class="${navClass}" aria-label="${escapeHtml(pickChrome('footerSocial', locale))}">${list}</nav>`;
  const wrapClass = [wrapBase, options?.wrapClass].filter(Boolean).join(' ');
  return `<div class="${escapeHtml(wrapClass)}">${heading}${nav}</div>`;
}
